<template>
    <div>
        <nav class="uiguide_nav">
            <div class="styleguideMenu">
                <ul>
                    <li v-for="template in sortTemplates(templates)" :key="template.id">
                        <span>{{template.name}}</span>
                        <ul>
                             <li v-for="item in template.items" :key="item.name">
                                <a @click="selectedTemplate = item" :style="{'active': selectedTemplate === item}">
                                    <span>{{item.name}}</span>
                                </a>
                            </li>
                        </ul>

                    </li>
                </ul>
            </div>
        </nav>
        <ComponentDetials v-if="selectedTemplate" :selectedTemplate="selectedTemplate" />
    </div>
</template>

<script>
import ComponentDetials from '@/components/component-details.vue';

export default {
    name: 'UGuide',
    methods: {
        sortTemplates: function (numbers) {
            var unique = numbers.map(item => item.section).filter((value, index, self) => self.indexOf(value) === index).sort();
            var navData = [];
            
            for( let x = 0; x < unique.length; x++ ){
                navData[x] = {
                    name:unique[x],
                    items: []
                };

                for( let i = 0; i < numbers.length; i++ ){

                    if ( numbers[i].section == unique[x]) {
                        navData[x].items.push(numbers[i]);
                    }

                }
            }
            return navData;
        }
    },
    data() {
        return {
            selectedTemplate: {
                    id: '1',
                    section: 'Home',
                    name: 'Welcome to the non ipr Micad Vue style guide',
                    description: 'This style guide includes elements designed to be used with the VUE framework.',
                    styles: ['The stand alone CSS is available here https://devtools.micadipr.net/UiGuide/vue/css', 'This style sheet can be used alongside the micad.css stylesheet.'],
                    template: false,
                    rules: ['']
                },
            templates: [
                {
                    id: '1',
                    section: 'Content',
                    name: 'Headers',
                    description: 'The Main heading is used as the title for the content of the page, A Heading is used as the title for as section of page content, Sub heading are used as the title for a sub section of page content.',
                    styles: [''],
                    template: true,
                    rules: ['Headings should be presented at the top of the page content.', 'Headings should use Sentance case not Camel case.', 'A main heading should not contain & symbols or dynamic text.','A main heading should be the same as the navigation element that point to it unless otherwise specified.']
                },
                {
                    id: '4',
                    section: 'Content',
                    name: 'Text',
                    description: 'Text is used to provide content on pages such as introductions or instructions.',
                    template: true,
                    styles: [''],
                    rules: ''
                },
                {
                    id: '5',
                    section: 'Content',
                    name: 'Unordered list',
                    description: 'An Unordered list is used to show list of items with not hierarchy.',
                    styles: ['List can be aligned horizontally by adding the class micad_unorderedList_horizontal to the base element'],
                    template: true,
                    rules: ['Text is left aligned']
                },
                 {
                    id: '6',
                    section: 'Content',
                    name: 'Description list',
                    description: 'A description list is used to show details organised in pairs of a labels with sets of values.',
                    styles: ['Description lists can be forced into a single column by adding the class micad_descriptionList_linearised to the base element'],
                    template: true,
                    rules: ['Description lists should be used instead of tables when column headers are not needed.']
                },
                {
                    id: '7',
                    section: 'Content',
                    name: 'Writing style',
                    description: 'The following guide provides details of how text should be phrased in non content areas of the system i.e. the navigation and warning messages. Note all content should be resourced to enable internationalisation.',
                    template: false,
                    rules: ['Navigation titles should indicate the name of the page the link goes to and not be an instruction.','Menu titles should be concise and succinct. i.e. It should be Delete item not Delete the item from the list.','If a sentence refers to dynamic content that can contain one or many items then an (s) should be used. i.e. It should be You are about to delete the following user(s)','In a label that refers to a value plural should be used i.e. Rooms = 1','Lables such as Column headers, description lists, forms should not end in a : (Colon)','Names should be written as such and in the following order First name, Other names, Last name.','User authentication is written Sign-On'],
                    styles: ['']
                },
                {
                    id: '8',
                    section: 'Content',
                    name: 'Vertical text',
                    description: 'The text direction can be set to vertical where space is at a premium.',
                    template: true,
                    styles: [''],
                    rules: ['']
                },
                 {
                    id: '9',
                    section: 'Content',
                    name: 'Link',
                    description: 'Links can be used for single navigation elements in the system.',
                    template: true,
                    styles: [''],
                    rules: ['All links should be in the standard style unless otherwise specified.', 'If more than one link need to be used a navigation element should be used.', 'Links should have a title to provide additional context.', 'Titles should not simply repeat the link text.']
                },
                {
                    id: '10',
                    section: 'Content',
                    name: 'Notes',
                    description: 'Notes can be used for small articles such as release notes.',
                    template: true,
                    styles: [''],
                    rules: ['']
                },
                {
                    id: '11',
                    section: 'Search',
                    name: 'Results list',
                    description: 'A result lists is used to display a series of links generated by searching or filtering.',
                    template: true,
                    styles: [''],
                    rules: ['Keywords are marked in the list if they formed a part of the search or filter criteria','The text in the list can be selected.']
                },
                {
                    id: '12',
                    section: 'Content',
                    name: 'Colours',
                    description: 'Colours used for branding, interface features and as signifiers.',
                    template: true,
                    styles: [''],
                    rules: ['Keywords are marked in the list if they formed a part of the search or filter criteria','The text in the list can be selected.']
                },
                {
                    id: '13',
                    section: 'Content',
                    name: 'Messages',
                    description: 'Messages can be used to provide the user with an important message. Waring messages can be used to alert the user to something has not happened as expected. Confirmation messages can be used to tell the user an action has taken place as expected',
                    template: true,
                    styles: [''],
                    rules: ['Massages should appear below the main neading unless specified.','Warning messages should describe actionable steps to help the user reach a resolution to their problem.','Warning messages should not contain error codes.']
                },
                {
                    id: '16',
                    section: 'Content',
                    name: 'Key',
                    description: 'The key is a list of symbols or labels that appear elsewhere on the page to allow further explanation.',
                    template: true,
                    styles: ['Description lists can be forced into a single column by adding the class micad_descriptionList_linearised to the base element'],
                    rules: ['']
                },
                {
                    id: '17',
                    section: 'Content',
                    name: 'Gallery (Not available yet)',
                    description: 'The gallery is used to display a series of images.',
                    template: false,
                    styles: [''],
                    rules: ['']
                },
                 {
                    id: '18',
                    section: 'Icons',
                    name: 'Risk icons',
                    description: 'Risk icons are used to represent different level of risk using colour',
                    template: true,
                    styles: [''],
                    rules: ['A text title must be used when using the colour icon alone.']
                },
                 {
                    id: '19',
                    section: 'Icons',
                    name: 'Loction level icons',
                    description: 'Location level icons use colour to represent region, site, building, room, floor levels.',
                    template: true,
                    styles: [''],
                    rules: ['A text title must be used when using the colour icon alone.']
                },
                {
                    id: '20',
                    section: 'Icons',
                    name: 'Destination level icon',
                    description: 'When linking to a different location level this icon is used to indicated the level the user is moving too.',
                    template: true,
                    styles: [''],
                    rules: ['A text title must be used when using the colour icon alone.']
                },
                {
                    id: '21',
                    section: 'Icons',
                    name: 'Flags',
                    description: 'Flag can be used to highlight text that has a special status. Warning flags are used to draw attaention towards something that requires attention. Confrmation flags indicate something has changed as expetianty.',
                    template: true,
                    styles: [''],
                    rules: ['']
                },
                {
                    id: '23',
                    section: 'Forms',
                    name: 'Forms',
                    description: 'Form structure, layout and use',
                    template: false,
                    styles: ['Form elements have three main features:','1.1 Label: The title of the field.',
                    '1.2 Control: The inputs and selectors.',
                    '1.3 Message: Text used to support the field such a help or a warning if validation has failed.', 
                    'The layout has a responsive design, Form elements are laid outhorizontaly at desktop resolutions and wrap under each other if the screen space is reduced for instance on a mobile device.'],
                    rules: ['Validation is presented correctly and on submission of data and not when the field is being completed', 
                    'When fields fail validation the focus should move to the first field in the tabbing order that has failed.', 
                    'Place holder text should only be used to indicate sanitisation rules i.e. a date field could have DD/MM/YY.', 
                    'When a page loads the focus should move to the first visible input field on the page (Typicaly folowing the tabbing order) This does not include Datagrids.', 
                    'If a field has focus choosing return should submit the form.', 
                    'Form labels and legends should be in Sentence case, not Camel case.']
                },
                {
                    id: '24',
                    section: 'Forms',
                    name: 'Text box',
                    description: 'Text boxes are used to capture numbers, words or short sentences of text.',
                    template: true,
                    styles: ['It comes in come in three sizes that can be set by adding micad_formElement_small micad_formElement_small micad_formElement_medium micad_formElement_large to the base element.', 
                    'The mandatory styling can be set by added micad_formElement_required to the base element.', 
                    'A warning state can be set by adding the class micad_formElement_warning to the base element.', 
                    'A disabled state can be set by adding the class micad_formElement_disabled to the base element.', 
                    'It can be displayed in a single column by adding the class micad_formElement_linearised to the base element.',
                    'Messages are optional'],
                    rules: ['']
                },
                {
                    id: '25',
                    section: 'Forms',
                    name: 'Check box',
                    description: 'Checkboxes allow the user to indicate a positive or negative choice by ticking a box.',
                    template: true,
                    styles: ['They can be displayed verticaly aligned by adding the class micad_formElement_vertical to the base element.',
                    'The mandatory styling can be set by added micad_formElement_required to the base element.', 
                    'A warning state can be set by adding the class micad_formElement_warning to the base element.', 
                    'A disabled state can be set by adding the class micad_formElement_disabled to the base element.', 
                    'It can be displayed in a single column by adding the class micad_formElement_linearised to the base element.',
                    'Messages are optional'],
                    rules: ['The checkbox can be activated by choosing the label associated with it.']
                },
                {
                id: '26',
                    section: 'Forms',
                    name: 'Radios',
                    description: 'Radio buttons allow the user to make a choice from a mutually exclusive set of options.',
                    template: true,
                    styles: ['They can be displayed verticaly aligned by adding the class micad_formElement_vertical to the base element.',
                    'The mandatory styling can be set by added micad_formElement_required to the base element.', 
                    'A warning state can be set by adding the class micad_formElement_warning to the base element.', 
                    'A disabled state can be set by adding the class micad_formElement_disabled to the base element.', 
                    'It can be displayed in a single column by adding the class micad_formElement_linearised to the base element.',
                    'Messages are optional'],
                    rules: ['The checkbox can be activated by choosing the label associated with it.']
                },
                 {
                id: '27',
                    section: 'Forms',
                    name: 'Dropdowns',
                    description: 'The Dropdown select is used to allow users to choose from a list of choices.',
                    template: true,
                    styles: ['The mandatory styling can be set by added micad_formElement_required to the base element.', 
                    'A warning state can be set by adding the class micad_formElement_warning to the base element.', 
                    'A disabled state can be set by adding the class micad_formElement_disabled to the base element.', 
                    'It can be displayed in a single column by adding the class micad_formElement_linearised to the base element.',
                    'Messages are optional'],
                    rules: ['A dropdown Select can have a blank option called Please choose unless specified otherwise.']
                },
                {
                id: '28',
                    section: 'Forms',
                    name: 'Textarea',
                    description: 'The textarea is used to capture text beyond a short sentences.',
                    template: true,
                    styles: ['The mandatory styling can be set by added micad_formElement_required to the base element.', 
                    'A warning state can be set by adding the class micad_formElement_warning to the base element.', 
                    'A disabled state can be set by adding the class micad_formElement_disabled to the base element.', 
                    'It can be displayed in a single column by adding the class micad_formElement_linearised to the base element.',
                    'Messages are optional'],
                    rules: ['']
                }, 
                {
                id: '29',
                    section: 'Forms',
                    name: 'Text box money',
                    description: 'The Textboxes money is used to indicate a monetary value is required.',
                    template: true,
                    styles: ['The mandatory styling can be set by added micad_formElement_required to the base element.', 
                    'A warning state can be set by adding the class micad_formElement_warning to the base element.', 
                    'A disabled state can be set by adding the class micad_formElement_disabled to the base element.', 
                    'It can be displayed in a single column by adding the class micad_formElement_linearised to the base element.',
                    'Messages are optional'],
                    rules: ['']
                },
                {
                id: '30',
                    section: 'Forms',
                    name: 'Text box percent',
                    description: 'The text boxes percent is used to indicate a percentage value is required.',
                    template: true,
                    styles: ['The mandatory styling can be set by added micad_formElement_required to the base element.', 
                    'A warning state can be set by adding the class micad_formElement_warning to the base element.', 
                    'A disabled state can be set by adding the class micad_formElement_disabled to the base element.', 
                    'It can be displayed in a single column by adding the class micad_formElement_linearised to the base element.',
                    'Messages are optional'],
                    rules: ['']
                },
                {
                id: '31',
                    section: 'Forms',
                    name: 'Year',
                    description: 'The year picker lets the user choose a year from a list.',
                    template: true,
                    styles: ['The mandatory styling can be set by added micad_formElement_required to the base element.', 
                    'A warning state can be set by adding the class micad_formElement_warning to the base element.', 
                    'A disabled state can be set by adding the class micad_formElement_disabled to the base element.', 
                    'It can be displayed in a single column by adding the class micad_formElement_linearised to the base element.',
                    'Messages are optional'],
                    rules: ['']
                },
                                {
                id: '32',
                    section: 'Forms',
                    name: 'Submit',
                    description: 'The Submit elementis used to accept or reject changes to the system.',
                    template: true,
                    styles: ['A disabled state can be set by adding the class micad_formElement_disabled to the base element.', 
                    'It can be displayed in a single column by adding the class micad_formElement_linearised to the base element.',
                    'Messages are optional'],
                    rules: ['Buttons that change the state of the data in the system i.e. post data from the page back to the server, should be called Submit unless otherwise specified.',
                    'Buttons that submit data should be in the primary call to action colour unless they are in a Datagrid.',
                    'Buttons that do not submit data, for instance buttons that filter data on the page should be in the secondary style.',
                    'A Cancel button should be presented to the right of the main button at the bottom of a form.']
                },
                {
                id: '33',
                    section: 'Forms',
                    name: 'Date',
                    description: 'The date picker allows the user to enter a date or choose a date from a calendar popover.',
                    template: true,
                    styles: ['The mandatory styling can be set by added micad_formElement_required to the base element.', 
                    'A warning state can be set by adding the class micad_formElement_warning to the base element.', 
                    'A disabled state can be set by adding the class micad_formElement_disabled to the base element.', 
                    'It can be displayed in a single column by adding the class micad_formElement_linearised to the base element.',
                    'Messages are optional'],
                    rules: ['']
                },
                {
                id: '34',
                    section: 'Forms',
                    name: 'Email',
                    description: 'The email box is used to help indicate to the user that an email is required.',
                    template: true,
                    styles: ['The mandatory styling can be set by added micad_formElement_required to the base element.', 
                    'A warning state can be set by adding the class micad_formElement_warning to the base element.', 
                    'A disabled state can be set by adding the class micad_formElement_disabled to the base element.', 
                    'It can be displayed in a single column by adding the class micad_formElement_linearised to the base element.',
                    'Messages are optional'],
                    rules: ['']
                },
                {
                id: '35',
                    section: 'Forms',
                    name: 'Text box button combo',
                    description: 'A way of inputing text and exciguting a query such as a search box or text filter.',
                    template: true,
                    styles: ['The mandatory styling can be set by added micad_formElement_required to the base element.', 
                    'A warning state can be set by adding the class micad_formElement_warning to the base element.', 
                    'A disabled state can be set by adding the class micad_formElement_disabled to the base element.', 
                    'It can be displayed in a single column by adding the class micad_formElement_linearised to the base element.',
                    'Messages are optional'],
                    rules: ['']
                },
                {
                id: '36',
                    section: 'Forms',
                    name: 'Text box dropdown combo',
                    description: 'This combo is good for combination of a Textbox for entering an amount and a Dropdown to choose a duration or measurment type.',
                    template: true,
                    styles: ['The mandatory styling can be set by added micad_formElement_required to the base element.', 
                    'A warning state can be set by adding the class micad_formElement_warning to the base element.', 
                    'A disabled state can be set by adding the class micad_formElement_disabled to the base element.', 
                    'It can be displayed in a single column by adding the class micad_formElement_linearised to the base element.',
                    'Messages are optional'],
                    rules: ['']
                },
                {
                id: '37',
                    section: 'Forms',
                    name: 'Start end date combo',
                    description: 'For entering the start and end dates of a period on a calendar.',
                    template: true,
                    styles: ['The mandatory styling can be set by added micad_formElement_required to the base element.', 
                    'A warning state can be set by adding the class micad_formElement_warning to the base element.', 
                    'A disabled state can be set by adding the class micad_formElement_disabled to the base element.', 
                    'It can be displayed in a single column by adding the class micad_formElement_linearised to the base element.',
                    'Messages are optional'],
                    rules: ['']
                },
                {
                id: '38',
                    section: 'Forms',
                    name: 'Checkbox text box combo',
                    description: 'Check box text box combo can be used to allow users to confirm a choice then add additional detail.',
                    template: true,
                    styles: ['The mandatory styling can be set by added micad_formElement_required to the base element.', 
                    'A warning state can be set by adding the class micad_formElement_warning to the base element.', 
                    'A disabled state can be set by adding the class micad_formElement_disabled to the base element.', 
                    'It can be displayed in a single column by adding the class micad_formElement_linearised to the base element.',
                    'Messages are optional'],
                    rules: ['']
                },
                {
                id: '39',
                    section: 'Forms',
                    name: 'Form legend',
                    description: 'The legend is a heading that defines set of form element in sits above.',
                    template: true,
                    styles: ['It can be displayed in a single column by adding the class micad_formElement_linearised to the base element.'],
                    rules: ['The Legend appears above a set of fields it defines.', 'Larger forms should be broken up into section with their own legends.', 'Legend title should be meaningful i.e. do not repeat the page title for instance if a page is called add new user the legend should be user details.']
                },
                {
                id: '40',
                    section: 'Forms',
                    name: 'Form',
                    description: 'The form is used to add a boundary to set of fields',
                    template: true,
                    styles: [''],
                    rules: ['Multiple Forms can be presented on a page.']
                },
                {
                id: '41',
                    section: 'Forms',
                    name: 'Read only',
                    description: 'The Read only field is used to add text to a form such as a message or a link.',
                    template: true,
                    styles: [''],
                    rules: ['']
                },
                {
                id: '42',
                    section: 'Forms',
                    name: 'Progress bar',
                    description: 'The progress bar displays visually how far something has progressed towards completion.',
                    template: true,
                    styles: [''],
                    rules: ['']
                },
                {
                id: '43',
                    section: 'Forms',
                    name: 'Container',
                    description: 'The container allows an uknown element to be put in the form.',
                    template: true,
                    styles: [''],
                    rules: ['']
                },
                {
                id: '44',
                    section: 'Main header',
                    name: 'User menu',
                    description: 'THe user menu is used to display a list of option that relate to the user or their administration of the system.',
                    template: true,
                    styles: [''],
                    rules: ['']
                },
                {
                id: '45',
                    section: 'Layout',
                    name: 'Tile grid',
                    description: 'The Tile grid is used to control the layout of multiple tiles',
                    template: true,
                    styles: [''],
                    rules: ['']
                },
                {
                id: '46',
                    section: 'Layout',
                    name: 'App laucher tile',
                    description: 'This tile is used on a portal or menu to lauch an application',
                    template: true,
                    styles: [''],
                    rules: ['']
                },
                {
                id: '47',
                    section: 'Icons',
                    name: 'Service icons',
                    description: 'These icons are used in reference to service applications',
                    template: true,
                    styles: [''],
                    rules: ['']
                },
                {
                id: '48',
                    section: 'Main header',
                    name: 'User details',
                    description: 'The user details is used to display the users name and role',
                    template: true,
                    styles: [''],
                    rules: ['']
                },
                {
                id: '49',
                    section: 'Main header',
                    name: 'Logo',
                    description: 'A logo is used to repreent a service or module',
                    template: true,
                    styles: [''],
                    rules: ['']
                },
                {
                id: '50',
                    section: 'Main header',
                    name: 'Portals header',
                    description: 'This is a persistant feature of portals and is a part of the page framework',
                    template: true,
                    styles: [''],
                    rules: ['']
                }
            ]
        }
    },
    components: {
        ComponentDetials
    },
}

</script>